import React, { useState, useEffect } from 'react';
import {app} from './firebaseconfig'
import {useForm} from 'react-hook-form'
import { Link, Redirect } from "react-router-dom";
import { useHistory } from 'react-router-dom';
import Header1 from "./Header"
import Footer from "./Footer"
import ReCAPTCHA from "react-google-recaptcha";
import LoadingBar from 'react-top-loading-bar'
import { Alert } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactGA from "react-ga"


 

function Upload() {
    const{register, handleSubmit, errors} = useForm()
    const db = app.firestore()
    const [user, setUser] = useState(null);
    const [userRob, setUserRob] = useState(false);
    const [progress1, setprogress] = React.useState(0)
    const [submitted, setSubmitted] = useState(false);

   
    

    useEffect(()=>{


      app.auth().onAuthStateChanged((user1) => {
        if (user1) {
          setUser({ user1 });
          localStorage.setItem('user', user1.uid);
        } else {
          setUser({ user: null });
          localStorage.removeItem('user');
        }
      });
    },[])

    const onChange1 = () =>{
      setUserRob({userRob: true})
    }


  const onSubmit = async (data) => {
    console.log(data.Document[0].type)
    
    if(data.Document[0].size < 31457280 ){
    if(data.Document[0].type=='image/jpeg' || data.Document[0].type=='application/vnd.openxmlformats-officedocument.wordprocessingml.document' || data.Document[0].type=='image/png' || data.Document[0].type=='image/cvs' || data.Document[0].type=='application/pdf' || data.Document[0].type=='application/vnd.openxmlformats-officedocument.presentationml.presentation'|| data.Document[0].type=='application/vnd.ms-powerpoint' || data.Document[0].type=='application/msword' || data.Document[0].type=='application/vnd.ms-excel' 
    || data.Document[0].type=='application/vnd.ms-powerpoint'  )
    {

    const C= data.college
    const N= data.SubjectCode + ' - ' + data.TypeOfDocument + ' - ' + data.Document[0].name 
      if(userRob && app.auth().currentUser ){
        setprogress(45)
    const storageRef= app.storage().ref(C)
    const fileRef =storageRef.child(N)
    await fileRef.put(data.Document[0])
    //if (N=="College of Engineering" || N=="College of Science" || N=="College of Business Administration" || N=="College of Arts" || N=="College of Information Technology"
    //|| N=="College of Health and Sport Sciences" || N=="College of Law" || N=="Bahrain Teachers College" || N=="College of Applied Studies"){
    const url = await fileRef.getDownloadURL().catch((error)=>{this.forceUpdate()});
    setprogress(65)
    const S=data.SubjectCode
    const S1= S.replace(/\s+/g, "");
    const S2=S1.toUpperCase();
    setprogress(85)
    db.collection(C).doc(N).set({
      Name: data.Document[0].name ,
      SentBy: app.auth().currentUser.email,
      College: C,
      Subject: S2,
      DocumentType: data.TypeOfDocument,
      URLOD: url,
      uplodedOn: new Date().toLocaleString('default', { day:"2-digit" , month: 'long' , year:'numeric' }),
      Size: data.Document[0].size,
    })
    ReactGA.initialize("UA-177281473-1", {siteSpeedSampleRate: 100})
    
    ReactGA.event({
      category:'Upload',
      action: "upload"
    })
    setprogress(100)
    setSubmitted(true)
   
  }}else{alert("This File Extention is not supported");}
 if(!userRob){alert("Please click the 'I'm not a robot button'")}
  }
   if (data.Document[0].size >= 31457280){alert("This File is very big");}
   //}else{alert("Something Went Wrong")}
 }

 

   return (
     <>
           <section id="cta2" className="container">
      <Header1></Header1>
      </section>
      <section className="box special">
        <h2>Upload Your Documents</h2><br></br>
       <form onSubmit={handleSubmit(onSubmit)}>

       {app.auth().currentUser ? (<div></div> ) : (<>  <Alert color="danger">
       You need to <a href="/login"> Login </a> before you upload your documents.
      </Alert> </>)}

      {submitted ? (<Alert color="success"> Your Document Has Been Uploaded Successfully</Alert> ) : (<div></div>)}
       
       
          <select name="college" ref={register({required: true, minLength: 13})}>
            <option>College</option>
            <option>College of Engineering</option>
            <option>College of Science</option>
            <option>College of Business Administration</option>
            <option>College of Arts</option>
            <option>College of Information Technology</option>
            <option>College of Health and Sport Sciences</option>
            <option>College of Law</option>
            <option>Bahrain Teachers College</option>
            <option>College of Applied Studies</option>
          </select><br></br> 
          {errors.college && <div>{"You must choose a college"}</div>}

         <input type="text" placeholder="Subject Code" name="SubjectCode" ref={register({required: true, minLength: 5 , maxLength: 9})}/> 
         {errors.SubjectCode && <div>{"Your entry must be between 5 and 9 characters"}</div>}<br></br>
      
         <select name="TypeOfDocument" ref={register({required: true, maxLength: 15})}>
            <option>Type of Document</option>
            <option>Notes</option>
            <option>Test 1</option>
            <option>Test 2</option>
            <option>Midterm Exam</option>
            <option>Final Exam</option>
            <option>Quiz</option>
            <option>Exercises</option>
            <option>Lab</option>
            <option>Other</option>
          </select><br></br> 
          {errors.TypeOfDocument && <div>{"This is Required"}</div>}

        <ReCAPTCHA
            sitekey="6LdcAL8ZAAAAAHXK3mYWyVlenuCsge4sBWXkK4AM"
            onChange={onChange1}
          />         
          <br></br>
      <input ref={register} required name="Document" type="file" /><br></br><br/>
      {app.auth().currentUser ? (<button className="button primary"> Submit </button> ) : (<Link to="/Login" className="button primary"> Login</Link>)}
      
      
      
      <LoadingBar
        color='#000000'
        progress={progress1}
        onLoaderFinished={() => setprogress(0)}
      />
        <br></br><br></br>
      
     
     </form>
     </section>
     <Footer></Footer>
     </>
   );

}

export default Upload;